import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { catchError, map, switchMap } from "rxjs/operators";
import { from, of } from "rxjs";

import { TelespotMethodTypeService } from "../../services";
import { methodTypeActions } from "./method-type.actions";

@Injectable()
export class TelespotMethodTypeEffects {
  constructor(
    private actions$: Actions,
    private service: TelespotMethodTypeService,
  ) { }

  findForSample = createEffect(() =>
    this.actions$.pipe(
      ofType(methodTypeActions.findForSample),
      switchMap(({ sampleId }) => from(this.service.findForSample(sampleId)).pipe(
        map(methodType => methodTypeActions.findForSampleSuccess({ methodType })),
        catchError((error) => of(methodTypeActions.findForSampleFailure({ error: error.message }))),
      )),
    )
  );
}
